import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ActivatedAlertTimeWillBeOver } from "../actions/SessionKonselingActions";

export default function useTrigerWaktu() {
  const [isWillBeEnd, setIsWillBeEnd] = useState(false);
  const dispatch = useDispatch();
  const storeWillBeEnd = useSelector(
    (state) => state.km_pduli_is_will_time_over
  );

  useEffect(() => {
    setIsWillBeEnd(storeWillBeEnd.value);
  }, [storeWillBeEnd]);

  const handleIsWillBeEnd = (v) => {
    dispatch(ActivatedAlertTimeWillBeOver(v));
  };
  return {
    handleIsWillBeEnd: handleIsWillBeEnd,
    isWillBeEnd: isWillBeEnd,
  };
}
